<template>
  <div
    v-loading="loading"
    class="tenantForm"
  >
    <div class="tenantForm__message">
      <p
        v-if="form.confirmed_at"
        class="tenantForm__message--success"
      >
        {{$t('records.tenant.form.emailConfirm')}}{{form.email}}{{$t('records.tenant.form.emailConfirmed')}}{{$moment(form.confirmed_at).format('DD/MM/YYYY, hh:mm')}}.
      </p>
      <p
        v-if="form.confirmation_sent_at && !form.confirmed_at"
        class="tenantForm__message--warning"
      >
        {{$t('records.tenant.form.emailConfirm')}}{{form.email}}{{$t('records.tenant.form.emailConfirmSent')}}{{$moment(form.confirmation_sent_at).format('DD/MM/YYYY, hh:mm')}}.
      </p>
    </div>
    <el-form
      ref="tenantForm"
      class="tenantForm"
      :model="form"
      :rules="rules"
      @submit.native.prevent="onSubmit"
    >
      <div class="tenantForm__form">
        <h4 v-if="editionMode">{{$t('records.tenant.form.title.edition')}}</h4>
        <h4 v-else>{{$t('records.tenant.form.title.creation')}}</h4>
        <p>{{$t('records.tenant.form.subtitle')}}</p>
        <!-- SITUATION -->
        <el-row :gutter="56">
          <el-col :lg="10">
            <el-form-item
              class="tenantForm__situation"
              :label="$t('records.tenant.form.situationLabel')"
            >
              <el-select
                v-model="form.situation"
                class="situationSelect"
                :placeholder="$t('records.tenant.form.situationPlaceholder')"
                @change="situationChange"
              >
                <el-option
                  v-for="situation in situations"
                  :key="situation"
                  :label="$t(`records.tenant.form.situations.${situation}`)"
                  :value="situation"
                >
                  {{ $t(`records.tenant.form.situations.${situation}`) }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div v-if="form.situation">
          <!-- GENDER -->
          <el-form-item
            class="tenantForm__gender"
            :label="$t('records.tenant.form.civilityLabel')"
            prop="gender"
          >
            <el-radio-group v-model="form.gender">
              <el-radio :label="'male'">{{$t('records.tenant.form.civilityMale')}}</el-radio>
              <el-radio :label="'female'">{{ $t('records.tenant.form.civilityFemale') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- FIRSTNAME & LASTNAME & MAIDENNAME -->
          <el-row :gutter="56">
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.firstNameLabel')"
                prop="first_name"
              >
                <el-input
                  v-model="form.first_name"
                  name="first_name"
                  :placeholder="$t('records.tenant.form.firstNamePlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.lastNameLabel')"
                prop="last_name"
              >
                <el-input
                  v-model="form.last_name"
                  name="last_name"
				          onkeyup="this.value=this.value.toUpperCase()"
				          class="uppercase"
                  :placeholder="$t('records.tenant.form.lastNamePlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="`${$t('records.tenant.form.originalLastNameLabel')}${form.gender === 'female' ? ' * :' : ' :'}`"
                prop="original_last_name"
              >

                <el-input
                  v-model="form.original_last_name"
                  name="original_last_name"
                  :placeholder="$t('records.tenant.form.originalLastNamePlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- EMAIL & PHONE_NUMBER -->
          <el-row :gutter="56">
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.emailLabel')"
                prop="email"
              >
                <el-input
                  v-model="form.email"
                  name="email"
                  :placeholder="$t('records.tenant.form.emailPlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.phoneNumberLabel')"
                prop="phone_number"
              >
                <phone-input
                  :data="{ localValue: form.phone_number, countryCode: form.phone_country_code }"
                  @update="updateTenantPhone"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ADDRESS -->
          <el-row
            v-show="form.situation !== 'international_student'"
            :gutter="56"
          >
            <el-col :lg="10">
              <el-form-item
                :label="$t('records.tenant.form.addressLabel')"
                prop="address"
              >
                <el-input
                  v-model="form.address"
                  type="textarea"
                  name="address"
                  :placeholder="$t('records.tenant.form.addressPlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ZIP_CODE & CITY & COUNTRY -->
          <el-row :gutter="56">
            <el-col
              v-show="form.situation !== 'international_student'"
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.zipCodeLabel')"
                prop="zip_code"
              >
                <el-input
                  v-model="form.zip_code"
                  name="zip_code"
                  :placeholder="$t('records.tenant.form.zipCodePlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="`${$t('records.tenant.form.cityLabel')} * :`"
                prop="city"
              >
                <el-input
                  v-model="form.city"
                  name="city"
                  :placeholder="$t('records.tenant.form.cityPlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.countryLabel')"
                prop="country_id"
              >
                <country-select
                  v-model="form.country_id"
                  :placeholder="$t('records.tenant.form.countryPlaceholder')"
                ></country-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- INTERNATIONAL_ADDRESS -->
          <el-row
            v-show="form.situation === 'international_student'"
            :gutter="56"
          >
            <el-col :lg="10">
              <el-form-item
                :label="$t('records.tenant.form.internationalAddressLabel')"
                prop="international_address"
              >
                <el-input
                  v-model="form.international_address"
                  name="international_address"
                  type="textarea"
                  :placeholder="$t('records.tenant.form.internationalAddressPlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- NATIONALITY & DATE_OF_BIRTH -->
          <el-row :gutter="56">
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.nationalityLabel')"
                prop="nationality_id"
              >
                <nationality-select
                  v-model="form.nationality_id"
                  :placeholder="$t('records.tenant.form.nationalityPlaceholder')"
                ></nationality-select>
              </el-form-item>
            </el-col>
            <el-col :lg="10">
              <el-form-item
                :label="$t('records.tenant.form.dateOfBirthLabel')"
                prop="date_of_birth"
              >
                <date-picker-input
                  v-model="form.date_of_birth"
                  :value="form.date_of_birth"
                  :disabled-date="dateValidation"
                  :placeholder="$t('records.tenant.form.dateOfBirthPlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- BIRTH_CITY & BIRTH_COUNTRY_ID & FAMILY_SITUATION_ID -->
          <el-row :gutter="56">
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.birthCityLabel')"
                prop="birth_city"
              >
                <el-input
                  v-model="form.birth_city"
                  name="birth_city"
                  :placeholder="$t('records.tenant.form.birthCityPlaceholder')"
                />
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.birthCountryLabel')"
                prop="birth_country_id"
              >
                <country-select
                  v-model="form.birth_country_id"
                  :placeholder="$t('records.tenant.form.birthCountryPlaceholder')"
                ></country-select>
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.familySituationLabel')"
                prop="family_situation_id"
              >
                <family-situation-select
                  v-model="form.family_situation_id"
                  :placeholder="$t('records.tenant.form.familySituationPlaceholder')"
                ></family-situation-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div>
            <!-- start of INFORMATIONS -->
            <h4>{{$t('records.tenant.form.informationsTitle')}}</h4>
            <p>{{ $t(`records.tenant.form.situations.${form.situation}`) }}</p>

            <!-- STUDY_ID & SCHOOL_TYPE_ID & SCHOOL_ID -->
            <el-row :gutter="56">
              <el-col
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="`${$t('records.tenant.form.studyIdLabel')}${form.situation === 'international_student' ? ' :' : ' * :'}`"
                  prop="study_id"
                >
                  <study-select
                    v-model="form.study_id"
                    :placeholder="$t('records.tenant.form.studyIdPlaceholder')"
                  ></study-select>
                </el-form-item>
              </el-col>
              <el-col
                v-show="['french_student', 'international_student', 'trainee', 'other'].includes(form.situation)"
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="$t('records.tenant.form.schoolTypeIdLabel')"
                  prop="school_type_id"
                >
                  <school-type-select
                    v-model="form.school_type_id"
                    :placeholder="$t('records.tenant.form.schoolTypeIdPlaceholder')"
                  ></school-type-select>
                </el-form-item>
              </el-col>
              <el-col
                v-show="['french_student', 'international_student', 'trainee', 'other'].includes(form.situation)"
                :sm="12"
                :lg="8"
              >

                <el-form-item
                  :label="$t('records.tenant.form.studySectorIdLabel')"
                  prop="study_sector_id"
                >
                  <study-sector-select
                    v-model="form.study_sector_id"
                    :placeholder="$t('records.tenant.form.studySectorIdPlaceholder')"
                  ></study-sector-select>
                </el-form-item>

              </el-col>
            </el-row>

            <!-- STUDY_SECTOR_ID & SCHOLARSHIP_OWNER -->
            <el-row :gutter="56">
              <el-col
                v-show="['french_student', 'international_student', 'trainee', 'other'].includes(form.situation)"
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="`${$t('records.tenant.form.schoolIdLabel')} :`"
                  prop="school_id"
                >
                  <school-select
                    v-model="form.school_id"
                    :title="schoolTitle"
                    :placeholder="$t('records.tenant.form.schoolIdPlaceholder')"
                  ></school-select>
                </el-form-item>
              </el-col>
              <el-col
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="$t('records.tenant.form.otherSchoolLabel')"
                  prop="other_school"
                >
                  <el-input
                    v-model="form.other_school"
                    name="other_school"
                    :placeholder="$t('records.tenant.form.otherSchoolPlaceholder')"
                  />
                </el-form-item>
              </el-col>
              <el-col v-show="form.situation !== 'employee'">
                <el-form-item
                  :label="$t('records.tenant.form.scholarshipOwnerLabel')"
                  prop="scholarship_owner"
                >
                  <el-radio-group
                    v-model="form.scholarship_owner"
                    class="tenantForm__scholarship"
                  >
                    <el-radio :label="true">
                      {{$t('records.tenant.form.radio_yes')}}
                    </el-radio>
                    <el-radio :label="false">
                      {{$t('records.tenant.form.radio_no')}}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- PARENTS_ADDRESS -->
            <el-row
              v-show="['french_student', 'other'].includes(form.situation)"
              :gutter="56"
            >
              <el-col :lg="10">
                <el-form-item
                  :label="$t('records.tenant.form.parentsAddressLabel')"
                  prop="parents_address"
                >
                  <el-input
                    v-model="form.parents_address"
                    type="textarea"
                    name="parents_address"
                    :placeholder="$t('records.tenant.form.parentsAddressPlaceholder')"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="2">

                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('records.tenant.form.copyTooltip')"
                  placement="bottom"
                >
                  <el-button
                    class="tenantForm__address_copy"
                    type="secondary"
                    @click="copyAddress"
                  >{{$t('records.tenant.form.copyButton')}}</el-button>
                </el-tooltip>
              </el-col>
            </el-row>

            <!-- PARENTS_ZIP_CODE & PARENTS_CITY & PARENTS_COUNTRY -->
            <el-row
              v-show="['french_student', 'other'].includes(form.situation)"
              :gutter="56"
            >
              <el-col
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="$t('records.tenant.form.parentsZipCodeLabel')"
                  prop="parents_zip_code"
                >
                  <el-input
                    v-model="form.parents_zip_code"
                    name="parents_zip_code"
                    :placeholder="$t('records.tenant.form.parentsZipCodePlaceholder')"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="$t('records.tenant.form.parentsCityLabel')"
                  prop="parents_city"
                >
                  <el-input
                    v-model="form.parents_city"
                    name="parents_city"
                    :placeholder="$t('records.tenant.form.parentsCityPlaceholder')"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :sm="12"
                :lg="8"
              >
                <el-form-item
                  :label="$t('records.tenant.form.parentsCountryLabel')"
                  prop="parents_country_id"
                >
                  <country-select
                    v-model="form.parents_country_id"
                    :value="form.parents_country_id"
                    :placeholder="$t('records.tenant.form.parentsCountryPlaceholder')"
                  ></country-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div v-show="['trainee', 'employee', 'other'].includes(form.situation)">
              <!-- company_name -->
              <el-row :gutter="56">
                <el-col :lg="10">
                  <el-form-item
                    :label="`${$t('records.tenant.form.companyNameLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="company_name"
                  >
                    <el-input
                      v-model="form.company_name"
                      name="company_name"
                      :placeholder="$t('records.tenant.form.companyNamePlaceholder')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- company_address-->
              <el-row :gutter="56">
                <el-col :lg="10">
                  <el-form-item
                    :label="`${$t('records.tenant.form.companyAddressLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="company_address"
                  >
                    <el-input
                      v-model="form.company_address"
                      type="textarea"
                      name="company_address"
                      :placeholder="$t('records.tenant.form.companyAddressPlaceholder')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- company_zip_code & company_city & company_country_id -->
              <el-row :gutter="56">
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.companyZipCodeLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="company_zip_code"
                  >
                    <el-input
                      v-model="form.company_zip_code"
                      name="company_zip_code"
                      :placeholder="$t('records.tenant.form.companyZipCodePlaceholder')"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.companyCityLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="company_city"
                  >
                    <el-input
                      v-model="form.company_city"
                      name="company_city"
                      :placeholder="$t('records.tenant.form.companyCityPlaceholder')"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.companyCountryLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="company_country_id"
                  >
                    <country-select
                      v-model="form.company_country_id"
                      :value="form.company_country_id"
                      :placeholder="$t('records.tenant.form.companyCountryPlaceholder')"
                    ></country-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- company_phone_number -->
              <el-row :gutter="56">
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.companyPhoneNumberLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="company_phone_number"
                  >
                    <phone-input
                      :data="{ localValue: form.company_phone_number, countryCode: form.company_phone_country_code }"
                      @update="updateCompanyPhone"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- occupation & activity_sector_id -->
              <el-row :gutter="56">
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.occupationLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="occupation"
                  >
                    <el-input
                      v-model="form.occupation"
                      name="occupation"
                      :placeholder="$t('records.tenant.form.occupationPlaceholder')"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.activitySectorLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="activity_sector_id"
                  >
                    <activity-sector-select
                      v-model="form.activity_sector_id"
                      :placeholder="$t('records.tenant.form.activitySectorPlaceholder')"
                    ></activity-sector-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- hiring_date & employment_contract_id -->
              <el-row :gutter="56">
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.hiringDateLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="hiring_date"
                  >
                    <date-picker-input
                      v-model="form.hiring_date"
                      :value="form.hiring_date"
                      :placeholder="$t('records.tenant.form.hiringDatePlaceholder')"
                    />
                    <span class="tenantForm__hint">{{$t('records.tenant.form.hiringDateHint')}}</span>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.employmentContractLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="employment_contract_id"
                  >
                    <employment-contract-select
                      v-model="form.employment_contract_id"
                      :placeholder="$t('records.tenant.form.employmentContractPlaceholder')"
                    ></employment-contract-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- net_monthly_income & monthly_family_allowances -->
              <el-row :gutter="56">
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="`${$t('records.tenant.form.netMonthlyIncomeLabel')}${form.situation === 'employee' ? ' * :' : ' :'}`"
                    prop="net_monthly_income"
                  >
                    <el-input
                      v-model.number="form.net_monthly_income"
                      name="net_monthly_income"
                      type="number"
                      :placeholder="$t('records.tenant.form.netMonthlyIncomePlaceholder')"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-show="form.situation === 'other'"
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.monthlyFamilyAllowancesLabel')"
                    prop="monthly_family_allowances"
                  >
                    <el-input
                      v-model.number="form.monthly_family_allowances"
                      name="monthly_family_allowances"
                      type="number"
                      :placeholder="$t('records.tenant.form.monthlyFamilyAllowancesPlaceholder')"
                    />
                    <span class="tenantForm__hint">{{$t('records.tenant.form.monthlyFamilyAllowancesHint')}}</span>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- other_monthly_income & other_monthly_income_details -->
              <el-row :gutter="56">
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.otherMonthlyIncomeLabel')"
                    prop="other_monthly_income"
                  >
                    <el-input
                      v-model.number="form.other_monthly_income"
                      name="other_monthly_income"
                      type="number"
                      :placeholder="$t('records.tenant.form.otherMonthlyIncomePlaceholder')"
                    />
                    <span class="tenantForm__hint">{{$t('records.tenant.form.otherMonthlyIncomeHint')}}</span>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.otherMonthlyIncomeDetailsLabel')"
                    prop="other_monthly_income_details"
                  >
                    <el-input
                      v-model="form.other_monthly_income_details"
                      type="textarea"
                      name="other_monthly_income_details"
                      :placeholder="$t('records.tenant.form.otherMonthlyIncomeDetailsPlaceholder')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- OWNER -->
              <el-form-item
                v-show="form.situation === 'other'"
                :label="$t('records.tenant.form.ownerLabel')"
                prop="owner"
              >
                <el-radio-group
                  v-model="form.owner"
                  class="tenantForm__radioGroup"
                >
                  <el-radio :label="true">
                    {{$t('records.tenant.form.radio_yes')}}
                  </el-radio>
                  <el-radio :label="false">
                    {{$t('records.tenant.form.radio_no')}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- monthly_rent_for_tenants & other_monthly_expenses -->
              <el-row
                v-show="form.situation === 'other'"
                :gutter="56"
              >
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.monthlyRentForTenantsLabel')"
                    prop="monthly_rent_for_tenants"
                  >
                    <el-input
                      v-model.number="form.monthly_rent_for_tenants"
                      name="monthly_rent_for_tenants"
                      type="number"
                      :placeholder="$t('records.tenant.form.monthlyRentForTenantsPlaceholder')"
                    />
                    <span class="tenantForm__hint">{{$t('records.tenant.form.monthlyRentForTenantsHint')}}</span>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.otherMonthlyExpensesLabel')"
                    prop="other_monthly_expenses"
                  >
                    <el-input
                      v-model.number="form.other_monthly_expenses"
                      name="other_monthly_expenses"
                      type="number"
                      :placeholder="$t('records.tenant.form.otherMonthlyExpensesPlaceholder')"
                    />
                    <span class="tenantForm__hint">{{$t('records.tenant.form.otherMonthlyExpensesHint')}}</span>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- financial_situation_comment -->
              <el-form-item
                :label="$t('records.tenant.form.financialSituationCommentLabel')"
                prop="financial_situation_comment"
              >
                <el-input
                  v-model="form.financial_situation_comment"
                  type="textarea"
                  name="financial_situation_comment"
                  :placeholder="$t('records.tenant.form.financialSituationCommentPlaceholder')"
                />
                <span class="tenantForm__hint">{{$t('records.tenant.form.financialSituationCommentHint')}}</span>
              </el-form-item>

              <!-- activity_started_at & retired_since -->
              <el-row
                v-show="form.situation === 'other'"
                :gutter="56"
              >
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.activityStartedAtLabel')"
                    prop="activity_started_at"
                  >
                    <date-picker-input
                      v-model="form.activity_started_at"
                      :value="form.activity_started_at"
                      :placeholder="$t('records.tenant.form.activityStartedAtPlaceholder')"
                    />
                    <span class="tenantForm__hint">{{$t('records.tenant.form.activityStartedAtHint')}}</span>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="12"
                  :lg="8"
                >
                  <el-form-item
                    :label="$t('records.tenant.form.retiredSinceLabel')"
                    prop="retired_since"
                  >
                    <date-picker-input
                      v-model="form.retired_since"
                      :value="form.retired_since"
                      :placeholder="$t('records.tenant.form.retiredSincePlaceholder')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- situation_comment -->
              <el-form-item
                v-show="form.situation === 'other'"
                :label="`${$t('records.tenant.form.situationCommentLabel')}${form.situation === 'other' ? ' * :' : ' :'}`"
                prop="situation_comment"
              >
                <el-input
                  v-model="form.situation_comment"
                  type="textarea"
                  name="situation_comment"
                  :placeholder="$t('records.tenant.form.situationCommentPlaceholder')"
                />
                <span class="tenantForm__hint">{{$t('records.tenant.form.situationCommentHint')}}</span>
              </el-form-item>
            </div>

            <!-- tax_revenue_year_minus_one & tax_revenue_year_minus_two -->
            <el-row :gutter="56">
              <el-col :lg="12">
                <el-form-item
                  :label="`${$t('records.tenant.form.taxRevenueYearMinusOneLabel')} * :`"
                  prop="tax_revenue_year_minus_one"
                >
                  <el-input
                    v-model.number="form.tax_revenue_year_minus_one"
                    name="tax_revenue_year_minus_one"
                    type="number"
                    :placeholder="$t('records.tenant.form.taxRevenueYearMinusOnePlaceholder')"
                  />
                  <span class="tenantForm__hint">{{$t('records.tenant.form.taxRevenueYearMinusOneHint')}}</span>
                </el-form-item>
              </el-col>
              <el-col
                :lg="12"
              >
                <el-form-item
                  :label="`${$t('records.tenant.form.taxRevenueYearMinusTwoLabel')} * :`"
                  prop="tax_revenue_year_minus_two"
                >
                  <el-input
                    v-model.number="form.tax_revenue_year_minus_two"
                    name="tax_revenue_year_minus_two"
                    type="number"
                    :placeholder="$t('records.tenant.form.taxRevenueYearMinusTwoPlaceholder')"
                  />
                  <span class="tenantForm__hint">{{$t('records.tenant.form.taxRevenueYearMinusTwoHint')}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- end of INFORMATIONS -->
          </div>

          <hr class="tenantForm__separator">

          <el-form-item prop="accept_sepa">
            <div :class="['checkboxFlex', form.accept_sepa ? 'checked' : '']">
              <el-checkbox v-model="form.accept_sepa" />
              <span @click="form.accept_sepa = !form.accept_sepa">
                {{$t('records.tenant.form.acceptSepaLabel')}}
              </span>
            </div>
          </el-form-item>

          <!-- BANK_IBAN & BANK_BIC -->
          <el-row
            v-show="form.accept_sepa"
            :gutter="56"
          >
            <el-col :lg="10">
              <el-form-item
                :label="$t('records.tenant.form.bankIbanLabel')"
                prop="bank_iban"
              >
                <el-input
                  v-model="form.bank_iban"
                  name="bank_iban"
                  :placeholder="$t('records.tenant.form.bankIbanPlaceholder')"
                />
                <span class="tenantForm__hint">{{$t('records.tenant.form.bankIbanHint')}}</span>
              </el-form-item>
            </el-col>
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.bankBicLabel')"
                prop="bank_bic"
              >
                <el-input
                  v-model="form.bank_bic"
                  name="bank_bic"
                  :placeholder="$t('records.tenant.form.bankBicPlaceholder')"
                />
                <span class="tenantForm__hint">{{$t('records.tenant.form.bankBicHint')}}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- BANK_NAME -->
          <el-row
            v-show="form.accept_sepa"
            :gutter="56"
          >
            <el-col
              :sm="12"
              :lg="8"
            >
              <el-form-item
                :label="$t('records.tenant.form.bankNameLabel')"
                prop="bank_name"
              >
                <el-input
                  v-model="form.bank_name"
                  name="bank_name"
                  :placeholder="$t('records.tenant.form.bankNamePlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="tenantForm__action">
        <el-row class="tenantForm__save-container">
          <el-col :sm="20">
            <p>
              {{ $t('records.tenant.form.save') }}
            </p>
          </el-col>
          <el-col :sm="4">
            <el-button
              class="tenantForm__save"
              type="secondary"
              :loading="inProgress"
              :disabled="!form.situation"
              native-type="submit"
            >{{ $t('records.tenant.form.continueButton') }}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import ActivitySectorSelect from "@/components/ui/ActivitySectorSelect"
import CountrySelect from "@/components/ui/CountrySelect"
import DatePickerInput from "@/components/ui/DatePickerInput"
import EmploymentContractSelect from "@/components/ui/EmploymentContractSelect"
import FamilySituationSelect from "@/components/ui/FamilySituationSelect"
import NationalitySelect from "@/components/ui/NationalitySelect"
import PhoneInput from "@/components/ui/PhoneInput"
import SchoolSelect from "@/components/ui/SchoolSelect"
import SchoolTypeSelect from "@/components/ui/SchoolTypeSelect"
import StudySectorSelect from "@/components/ui/StudySectorSelect"
import StudySelect from "@/components/ui/StudySelect"
import { mapState } from 'vuex'

export default {
  name: 'TenantForm',
  components: {
    ActivitySectorSelect,
    CountrySelect,
    DatePickerInput,
    EmploymentContractSelect,
    FamilySituationSelect,
    NationalitySelect,
    PhoneInput,
    SchoolSelect,
    SchoolTypeSelect,
    StudySectorSelect,
    StudySelect
  },
  data: () => ({
    loading: false,
    inProgress: false,
    situations: ['french_student', 'international_student', 'trainee', 'employee', 'other'],
    defaultForm: {
      situation: null,
      gender: null,
      first_name: null,
      last_name: null,
      original_last_name: null,
      email: null,
      phone_number: null,
      phone_country_code: null,
      address: null,
      zip_code: null,
      city: null,
      country_id: null,
      international_address: null,
      date_of_birth: null,
      birth_city: null,
      birth_country_id: null,
      nationality_id: null,
      family_situation_id: null,
      study_id: null,
      school_type_id: null,
      school_id: null,
      other_school: null,
      study_sector_id: null,
      scholarship_owner: null,
      parents_address: null,
      parents_zip_code: null,
      parents_city: null,
      parents_country_id: null,
      company_name: null,
      company_address: null,
      company_zip_code: null,
      company_city: null,
      company_country_id: null,
      company_phone_number: null,
      company_phone_country_code: null,
      occupation: null,
      activity_sector_id: null,
      hiring_date: null,
      employment_contract_id: null,
      net_monthly_income: null,
      monthly_family_allowances: null,
      other_monthly_income: null,
      other_monthly_income_details: null,
      owner: true,
      monthly_rent_for_tenants: null,
      other_monthly_expenses: null,
      financial_situation_comment: null,
      activity_started_at: null,
      retired_since: null,
      situation_comment: null,
      tax_revenue_year_minus_one: null,
      tax_revenue_year_minus_two: null,
      accept_sepa: false,
      bank_iban: null,
      bank_bic: null,
      bank_name: null
    },
    form: {}
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord,
      currentRecordTenantId: state => state.recordsPeople.currentRecordTenants && state.recordsPeople.currentRecordTenants.length > 0 ?
        state.recordsPeople.currentRecordTenants[state.recordsPeople.currentRecordTenants.length - 1].id : null
    }),
    editionMode() {
      return !!this.$route.params.tenant_id
    },
    rules() {
      return {
        situation: { required: true, type: 'string', message: this.$t('records.tenant.form.situationInvalid') },
        gender: { required: true, type: 'string', message: this.$t('records.tenant.form.civilityInvalid') },
        first_name: { required: true, type: 'string', message: this.$t('records.tenant.form.firstNameInvalid') },
        last_name: { required: true, type: 'string', message: this.$t('records.tenant.form.lastNameInvalid') },
        original_last_name: { required: this.form.situation === 'female', type: 'string', message: this.$t('records.tenant.form.originalLastNameInvalid') },
        email: { type: "email", required: true, trigger: 'blur', message: this.$t('records.tenant.form.emailInvalid') },
        phone_number: { required: true, type: 'string', message: this.$t('records.tenant.form.phoneNumberInvalid') },
        address: { required: this.form.situation !== 'international_student', type: 'string', message: this.$t('records.tenant.form.addressInvalid') },
        zip_code: { required: this.form.situation !== 'international_student', type: 'string', message: this.$t('records.tenant.form.zipCodeInvalid') },
        city: { required: true, type: 'string', message: this.$t('records.tenant.form.cityInvalid') },
        country_id: { required: true, type: 'number', message: this.$t('records.tenant.form.countryInvalid') },
        international_address: { required: this.form.situation === 'international_student', type: 'string', message: this.$t('records.tenant.form.internationalAddressInvalid') },
        nationality_id: { required: true, type: 'number', message: this.$t('records.tenant.form.nationalityInvalid') },
        date_of_birth: { required: true, type: 'string', message: this.$t('records.tenant.form.dateOfBirthInvalid') },
        birth_city: { required: true, type: 'string', message: this.$t('records.tenant.form.birthCityInvalid') },
        birth_country_id: { required: true, type: 'number', message: this.$t('records.tenant.form.birthCountryInvalid') },
        family_situation_id: { required: true, type: 'number', message: this.$t('records.tenant.form.familySituationInvalid') },
        study_id: { required: true, type: 'number', message: this.$t('records.tenant.form.studyIdInvalid') },
        school_type_id: { required: false, type: 'number', message: this.$t('records.tenant.form.schoolTypeIdInvalid') },
        school_id: { required: false, type: 'number', message: this.$t('records.tenant.form.schoolIdInvalid') },
        other_school: { required: false, type: 'string', message: this.$t('records.tenant.form.otherSchoolIdInvalid') },
        study_sector_id: { required: false, type: 'number', message: this.$t('records.tenant.form.studySectorIdInvalid') },
        scholarship_owner: { required: this.form.situation !== 'employee', type: 'boolean', message: this.$t('records.tenant.form.scholarshipOwnerInvalid') },
        parents_address: { required: false, type: 'string', message: this.$t('records.tenant.form.parentsAddressInvalid') },
        parents_zip_code: { required: false, type: 'string', message: this.$t('records.tenant.form.parentsZipCodeInvalid') },
        parents_city: { required: false, type: 'string', message: this.$t('records.tenant.form.parentsCityInvalid') },
        parents_country_id: { required: false, message: this.$t('records.tenant.form.parentsCountryInvalid') },
        company_name: { required: this.form.situation === 'employee', type: 'string', message: this.$t('records.tenant.form.companyNameInvalid') },
        company_address: { required: false, type: 'string', message: this.$t('records.tenant.form.companyAddressInvalid') },
        company_zip_code: { required: false, type: 'string', message: this.$t('records.tenant.form.companyZipCodeInvalid') },
        company_city: { required: false, type: 'string', message: this.$t('records.tenant.form.companyCityInvalid') },
        company_country_id: { required: false, type: 'number', message: this.$t('records.tenant.form.companyCountryInvalid') },
        company_phone_number: { required: false, type: 'string', message: this.$t('records.tenant.form.companyPhoneNumberInvalid') },
        occupation: { required: false, type: 'string', message: this.$t('records.tenant.form.occupationInvalid') },
        activity_sector_id: { required: false, type: 'number', message: this.$t('records.tenant.form.activitySectorInvalid') },
        hiring_date: { required: false, type: 'string', message: this.$t('records.tenant.form.hiringDateInvalid') },
        employment_contract_id: { required: false, type: 'number', message: this.$t('records.tenant.form.employmentContractInvalid') },
        net_monthly_income: { required: false, type: 'number', message: this.$t('records.tenant.form.netMonthlyIncomeInvalid') },
        monthly_family_allowances: { required: false, type: 'number', message: this.$t('records.tenant.form.monthlyFamilyAllowancesInvalid') },
        other_monthly_income: { required: false, type: 'number', message: this.$t('records.tenant.form.otherMonthlyIncomeInvalid') },
        other_monthly_income_details: { required: false, type: 'string', message: this.$t('records.tenant.form.otherMonthlyIncomeDetailsInvalid') },
        owner: { required: false, type: 'boolean', message: this.$t('records.tenant.form.ownerInvalid') },
        monthly_rent_for_tenants: { required: false, type: 'number', message: this.$t('records.tenant.form.monthlyRentForTenantsInvalid') },
        other_monthly_expenses: { required: false, type: 'number', message: this.$t('records.tenant.form.otherMonthlyExpensesInvalid') },
        financial_situation_comment: { required: false, type: 'string', message: this.$t('records.tenant.form.financialSituationCommentInvalid') },
        activity_started_at: { required: false, type: 'string', message: this.$t('records.tenant.form.activityStartedAtInvalid') },
        retired_since: { required: false, type: 'string', message: this.$t('records.tenant.form.retiredSinceInvalid') },
        situation_comment: { required: this.form.situation === 'other', type: 'string', message: this.$t('records.tenant.form.situationCommentInvalid') },
        tax_revenue_year_minus_one: { required: true, type: 'number', message: this.$t('records.tenant.form.taxRevenueYearMinusOneInvalid') },
        tax_revenue_year_minus_two: { required: true, type: 'number', message: this.$t('records.tenant.form.taxRevenueYearMinusTwoInvalid') },
        // end
        bank_iban: { required: this.form.accept_sepa, type: 'string', message: this.$t('records.tenant.form.bankIbanInvalid') },
        bank_bic: { required: this.form.accept_sepa, type: 'string', message: this.$t('records.tenant.form.bankBicInvalid') },
        bank_name: { required: this.form.accept_sepa, type: 'string', message: this.$t('records.tenant.form.bankNameInvalid') }
      }
    },
    tenantId() {
      if (this.$route.params.tenant_id) {
        return this.$route.params.tenant_id
      } else {
        return this.$store.getters['recordsPeople/tenantId']
      }
    },
    schoolTitle() {
      return this.form.school ? this.form.school.title : ''
    }
  },
  watch: {
    tenantId: {
      immediate: true,
      async handler(newVal) {
        this.loading = true
        if (newVal) {
          this.form = this.$helpers.conversionHelper(await this.$api.recordsPeople.getTenant({ id: newVal }))
        } else {
          this.form = Object.assign({}, this.defaultForm)
        }
        this.loading = false
      }
    }
  },
  mounted() {
    Object.assign(this.form, this.defaultForm)
  },
  methods: {
    situationChange() {
      setTimeout(() => {
        // reset form validation
        this.$refs['tenantForm'].resetFields()
      }, 250)
    },
    copyAddress() {
      this.form.parents_address = this.form.address
      this.form.parents_zip_code = this.form.zip_code
      this.form.parents_city = this.form.city
      this.form.parents_country_id = this.form.country_id
    },
    async onSubmit() {
      try {
        this.inProgress = true
        const validation = await this.$refs['tenantForm'].validate()

        if (this.form.situation === 'employee') {
          this.form.scholarship_owner = false
        }

        if (validation) {
          let message = ''
          if (this.editionMode) {
            await this.$store.dispatch('recordsPeople/updateTenant', { tenant: this.form })
            message = this.$t('records.tenant.form.message.updated')
          } else if (this.tenantId) {
            await this.$store.dispatch('records/updateRecord', { record: { tenant_ids: [...this.currentRecord.tenant_ids, this.tenantId] }, id: this.$route.params.id })
            this.$router.push({
              path: '/dossiers/' + this.currentRecord.id + '/ajout-de-garant'
            })
          } else {
            await this.$store.dispatch('recordsPeople/createTenant', { tenant: this.form, record_id: this.$route.params.id })
            message = this.$t('records.tenant.form.message.created')
            this.$router.push({
              path: '/dossiers/' + this.currentRecord.id + '/ajout-de-garant'
            })
          }
          this.$notify({
            type: 'success',
            title: this.$t('base.success.notificationTitle'),
            message
          })
        }
        this.inProgress = false
      } catch (error) {
        this.inProgress = false
      }
    },
    dateValidation(date) {
      return this.$moment().diff(date, 'years') < 16
    },
    updateTenantPhone(event) {
      this.form.phone_number = event.phoneNumber
      this.form.phone_country_code = event.countryCode
    },
    updateCompanyPhone(event) {
      this.form.company_phone_number = event.phoneNumber
      this.form.company_phone_country_code = event.countryCode
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.tenantForm';

#{$c} {
  margin-bottom: 24px;

  &__message {
    font-size: 21px;
    font-weight: 600;
    word-break: break-word;

    &--success {
      color: #207468;
    }
    &--warning {
      color: #b7202e;
    }
  }
  &__form,
  &__action {
    background-color: white;
  }
  &__form {
    margin-bottom: 24px;
  }
  &__form p {
    margin-bottom: 30px;
    margin-top: 0;
  }

  &__hint {
    color: $--color-info;
  }

  &__address_copy {
    @include respond-above(lg) {
      margin-top: 40px;
    }
  }

  &__save-container {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      color: $--color-info;
    }

    .el-col:nth-child(2) {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
  }

  &__separator {
    border: 1px solid $--border-color-light;
  }

  .el-select,
  .el-date-editor {
    width: 100%;
  }

  .checkboxFlex {
    display: flex;
    align-items: center;

    span {
      line-height: 1.2;
      cursor: pointer;
      user-select: none;
      color: #606266;
    }
  }
  .checkboxFlex.checked span {
    color: $--color-primary;
    font-size: 16px;
  }
}
</style>